<template>
  <div
    class="row footer-sub-nav"
    :class="{'footer-sub-nav--store-footer': isStore}"
  >
    <div class="col">
      <div class="footer-sub-nav__wrapper">
        <div
          v-if="address || phoneNumber"
          class="footer-sub-nav__company_profile"
        >
          <no-ssr>
            <svgicon
              title="ICA"
              :name="icaLogo"
              class="footer-sub-nav__logo ica-logo"
              role="presentation"
            />
          </no-ssr>

          <div class="footer-sub-nav__company-info">
            <p
              v-if="isStore"
              v-text="storeName"
            />
            <p v-text="address" />
            <a
              class="footer-sub-nav__phone-number"
              :href="`tel:${phoneNumber}`"
              v-text="phoneNumber"
            />
          </div>
        </div>

        <div
          v-if="!isStore"
          class="footer-sub-nav__services"
        >
          <a href="https://www.apotekhjartat.se/">
            <no-ssr placeholder="Apotek hjärtat">
              <svgicon
                title="Apotek hjärtat"
                :name="servicesIcons.pharmacy"
                class="pharmacy"
              />
            </no-ssr>
          </a>
          <a href="https://www.icabanken.se/">
            <no-ssr placeholder="ICA Banken">
              <svgicon
                title="ICA Banken"
                :name="servicesIcons.bank"
                class="bank"
              />
            </no-ssr>
          </a>
          <a href="https://www.icaforsakring.se/">
            <no-ssr placeholder="ICA Försäkring">
              <svgicon
                title="ICA Försäkring"
                :name="servicesIcons.insurance"
                class="insurance"
              />
            </no-ssr>
          </a>
        </div>


        <div class="footer-sub-nav__social">
          <a href="http://www.facebook.com/ICA">
            <no-ssr placeholder="ICA på Facebook">
              <svgicon
                title="ICA på Facebook"
                :name="socialIcons.facebook"
                class="facebook"
              />
            </no-ssr>
          </a>
          <a href="https://www.instagram.com/icasverige">
            <no-ssr placeholder="ICA på Instagram">
              <svgicon
                title="ICA på Instagram"
                :name="socialIcons.instagram"
                class="instagram"
              />
            </no-ssr>
          </a>
          <a href="https://www.youtube.com/user/ica">
            <no-ssr placeholder="ICA på Youtube">
              <svgicon
                title="ICA på Youtube"
                :name="socialIcons.youtube"
                class="youtube"
              />
            </no-ssr>
          </a>
          <a href="https://twitter.com/icagruppen">
            <no-ssr placeholder="ICA på Twitter">
              <svgicon
                title="ICA på Twitter"
                :name="socialIcons.twitter"
                class="twitter"
              />
            </no-ssr>
          </a>
        </div>
        <div class="footer-sub-nav__apps">
          <!-- show icon google play if android -->
          <template v-if="isAndroid || !isIOS">
            <a
              href="https://play.google.com/store/apps/details?id=se.ica.handla&feature=search_result#?t=W251bGwsMSwxLDEsInNlLmljYS5oYW5kbGEiXQ"
            >
              <no-ssr placeholder="Appen ICA för Android">
                <svgicon
                  title="Appen ICA för Android"
                  :name="appIcons.googlePlay"
                  :original="true"
                  :fill="false"
                  class="google-play"
                />
              </no-ssr>

            </a>
          </template>
          <!-- Show icon for App store if IOS  -->
          <template v-if="isIOS || !isAndroid">
            <a href="https://itunes.apple.com/se/app/ica/id458324110?mt=8">
              <no-ssr placeholder="Appen ICA för Iphone och Ipad">
                <svgicon
                  title="Appen ICA för Iphone och Ipad"
                  :name="appIcons.appStore"
                  :original="true"
                  :fill="false"
                  class="app-store"
                />
              </no-ssr>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
Currently used icons in subnav, import exclusively to minimize js
import "@/icons/Logos/ICA"
import "@/icons/Services/Pharmacy"
import "@/icons/Services/Bank"
import "@/icons/Services/Insurance"
import "@/icons/Social/Facebook"
import "@/icons/Social/Instagram"
import "@/icons/Social/YouTube"
import "@/icons/Social/Twitter"
import "@/icons/AppStore/GooglePlay"
import "@/icons/AppStore/AppStore"
*/
export default {
  props: {
    address: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    storeName: {
      type: String,
      default: ''
    },
    isStore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icaLogo: 'Logos/ICA',
      servicesIcons: {
        pharmacy: 'Services/Pharmacy',
        bank: 'Services/Bank',
        insurance: 'Services/Insurance'
      },
      socialIcons: {
        facebook: 'Social/Facebook',
        instagram: 'Social/instagram',
        youtube: 'Social/YouTube',
        twitter: 'Social/Twitter'
      },
      appIcons: {
        googlePlay: 'AppStore/GooglePlay',
        appStore: 'AppStore/AppStore'
      },
      isIOS: false,
      isAndroid: false
    }
  },
  mounted () {
    if (!SSR_MODE) {
      this.$data.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      this.$data.isAndroid = /(android)/i.test(navigator.userAgent)

    }
  },
}
</script>

<style lang="scss">
.footer-sub-nav {
  $this: &;

  &--store-footer {
    #{$this}__company_profile {
      flex-wrap: wrap;
      border-bottom: 1px solid $color-grey-special;
      margin-bottom: 10px;

      @include media-breakpoint-up(md) {
        border-bottom: 0;
        margin-bottom: 0;
        width: auto;
        padding-bottom: 0;
      }
    }

    #{$this}__logo {
      margin-bottom: 7px;
    }
  }

  padding-top: 1.1875rem;

  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__logo {
    width: 3.375rem;
    height: 1.6875rem;
    margin-right: 1.5rem;
    margin-bottom: 0.1875rem;

    &.svg-icon {
      fill: $color-red;
    }
  }

  &__company_profile {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: 100%;
    padding-bottom: 1rem;

    @include media-breakpoint-up(xl) {
      margin-right: auto;
      padding-bottom: 0;
      width: auto;
    }

    p {
      margin: 0;
      color: $color-secondary-text;

      @include font(text, 2, normal);
    }
  }

  &__phone-number {
    text-decoration: none;
    color: $color-secondary-text;

    @include font(text, 2, normal);
  }

  &__services {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
    padding-bottom: 1.5rem;
    justify-content: space-between;
    width: 100%;
    border-bottom: 0.0625rem solid  $color-grey-special;

    @include media-breakpoint-up(md) {
      margin-bottom: 0;
      width: auto;
      align-items: center;
      border: 0;
      padding-bottom: 0;

      &::after {
        content: none;
      }
    }

    @include media-breakpoint-up(xl) {
      justify-content: center;
      align-self: center;
      padding-bottom: 0;
    }

    a {
      @include media-breakpoint-up(md) {
        margin-right: 1rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  &__social {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: auto;

    @include media-breakpoint-up(md) {
      margin-left: auto;
    }

    @include media-breakpoint-up(xl) {
      padding-bottom: 0;
    }

    a {
      margin-right: 1.5rem;
    }
  }

  &__apps {
    a {
      display: inline-block;
    }
  }

  .svg-icon {
    fill: $color-grey-light;

    &.ica-logo {
      fill: $color-red;
    }

    &.pharmacy {
      width: 5.875rem;
      height: 0.9375rem;

      @include media-breakpoint-up(md) {
        width: 7.3125rem;
        height: 3rem;
        margin-bottom: -0.125rem;
      }
    }

    &.bank {
      width: 5rem;
      height: 0.875rem;

      @include media-breakpoint-up(md) {
        width: 6.1875rem;
        height: 1.0625rem;
      }
    }

    &.insurance {
      width: 6.0625rem;
      height: 0.9375rem;
      margin-bottom: -0.125rem;

      @include media-breakpoint-up(md) {
        width: 7.5rem;
        height: 1.1875rem;
        margin-bottom: -0.25rem;
      }
    }

    &.facebook {
      width: 1.25rem;
      height: 1.25rem;
    }

    &.instagram {
      width: 1.25rem;
      height: 1.25rem;
    }

    &.youtube {
      width: 1.25rem;
      height: 1.25rem;
    }

    &.twitter {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .app-store {
    width: 5.875rem;
    height: 2rem;
  }

  .google-play {
    width: 6.6875rem;
    height: 2rem;
  }
}
</style>
